module.exports = __webpack_public_path__ + "static/0.0_Heart_Shield_Icon_Gradient-01-70189abae408369189369dccf7a7a329.png";